<!-- klasik kabuk -->
<ng-container *ngIf="!isModernThemeRequested()">
  <!-- vertical layout -->
  <app-vertical *ngIf="isVerticalLayoutRequested()"></app-vertical>

  <!-- horizontal layout -->
  <app-horizontal *ngIf="isHorizontalLayoutRequested()"></app-horizontal>
</ng-container>

<!-- modern kabuk (yeni tasarım) -->
<app-modern *ngIf="isModernThemeRequested()"></app-modern>
